module.exports = __webpack_public_path__ + "img/loginLogo.c94ed351.png";